import { useContext } from "react";
import { userDataContext } from "@/hooks/useUserData";
import { SAMBO_KUN_PARTNER_ID } from "@/features/partner/constants";

/**
 * 現在のログインユーザーが参謀くん連携ユーザーかどうかを返す hook。
 *
 * SSO 連携済みパートナー ID の一覧（`ssoPartnerIds`）に参謀くんの ID（{@link SAMBO_KUN_PARTNER_ID}）が
 * 含まれているかを確認する。
 *
 * @returns ログインユーザーが参謀くん連携済みの場合 `true`、そうでない場合 `false`
 */
export const useIsSamboKunUser = (): boolean => {
  const userData = useContext(userDataContext);
  return userData.data.ssoPartnerIds.includes(SAMBO_KUN_PARTNER_ID);
};
